/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2024-07-12 10:18:15
 * @LastEditors:
 * @LastEditTime: 2024-07-12 11:16:46
 */
import { requestOfPut, requestOfGet, requestOfPost } from "../utils/http";
const baseUrl = "wechath5/zh-cn/v1/lotterydraw";

export function getDrawActivityInfo(param) {
  return requestOfGet("wechath5/zh-cn/v1/event/lotterydraw" + "/" + param.id);
}
export function getDrawTimesByShare(param) {
  return requestOfPost(baseUrl + "/share", param);
}
export function getDrawGiftList(param) {
  return requestOfGet(baseUrl + "/goods", param);
}

export function getDrawTimesByPoint(param) {
  return requestOfPost(baseUrl + "/payintegral", param);
}
export function submitDraw(param) {
  return requestOfPost(baseUrl + "/do", param);
}
export function getDrawGiftLogList(param) {
  return requestOfGet(baseUrl + "/logs", param);
}
